import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';

export const useNoTileDataToast = ({ map, sourceId, sourceLayer, message, minZoom = 0 }) => {
  const isEmptyRef = useRef(false);

  useEffect(() => {
    if (!map || !sourceId || !message) return undefined;
    const toastId = `no-data-${sourceId}`;

    const checkForData = () => {
      if (map.getZoom() < minZoom || !map.getSource(sourceId)) {
        isEmptyRef.current = false;
        toast.dismiss(toastId);
        return;
      }
      if (!map.isSourceLoaded(sourceId)) return;

      const isEmpty = map.querySourceFeatures(sourceId, { sourceLayer }).length === 0;
      // Only toast when transitioning into an empty area, so panning around an empty area doesn't re-trigger it.
      if (isEmpty && !isEmptyRef.current) toast.info(message, { toastId });
      if (!isEmpty) toast.dismiss(toastId);
      isEmptyRef.current = isEmpty;
    };

    map.on('idle', checkForData);
    return () => {
      map.off('idle', checkForData);
      toast.dismiss(toastId);
      isEmptyRef.current = false;
    };
  }, [map, sourceId, sourceLayer, message, minZoom]);
};
